import React, { Component } from "react";

export default class Introduction extends Component {
  render() {
    return (
      <div>
        {/* <section
          id="colorlib-hero"
          className="js-fullheight"
          data-section="home"
        >
          <div className="flexslider js-fullheight">
            <ul className="slides">
              <li
                style={{
                  backgroundImage: "url(images/casa_pic_4.jpg)",
                  backgroundSize: "cover",
                }}
              >
                <div className="overlay" />
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight slider-text">
                      <div className="slider-text-inner js-fullheight">
                        <div className="desc">
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          ></div>

                          <button
                            style={{
                              backgroundColor: "#ECE5DD",
                              borderRadius: "20px",
                              borderColor: "rgb(67, 197, 158)",
                              border: "none",
                              position: "absolute",
                              bottom: "145px",
                              left: "10px",
                            }}
                          >
                            <span
                              style={{
                                color: "black",
                                fontSize: "22px",
                                padding: "10px",
                              }}
                            >
                              Hi
                            </span>
                          </button>

                          <button
                            style={{
                              backgroundColor: "#ECE5DD",
                              borderRadius: "20px",
                              borderColor: "rgb(67, 197, 158)",
                              border: "none",
                              position: "absolute",
                              bottom: "90px",
                              left: "10px",
                            }}
                          >
                            <span
                              style={{
                                color: "black",
                                fontSize: "22px",
                                padding: "10px",
                              }}
                            >
                              I'm Mohamed
                            </span>
                          </button>

                          <button
                            style={{
                              backgroundColor: "rgb(67, 197, 158)",
                              borderRadius: "20px",
                              position: "absolute",
                              bottom: "20px",
                              left: "10px",
                            }}
                          >
                            <span
                              style={{
                                color: "white",
                                fontSize: "22px",
                                fontFamily: "'Noto Sans JP',  sans-serif",
                                margin: "20px",
                                width: "100px",
                              }}
                            >
                              <i
                                className="icon-whatsapp"
                                style={{ marginRight: "7px", fontSize: "22px" }}
                              />{" "}
                              212 777 757 183
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li
                style={{
                  backgroundImage: "url(images/casa_pic_2.jpg)",
                  backgroundSize: "cover",
                }}
              >
                <div className="overlay" />
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-6 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight slider-text">
                      <div className="slider-text-inner">
                        <div className="desc">
                          <div className="desc">
                            <div>
                              <button
                                style={{
                                  backgroundColor: "#ECE5DD",
                                  borderRadius: "20px",
                                  borderColor: "rgb(67, 197, 158)",
                                  border: "none",
                                  position: "absolute",
                                  bottom: "140px",
                                  left: "10px",
                                }}
                              >
                                <span
                                  style={{
                                    color: "black",
                                    fontSize: "18px",
                                    padding: "10px",
                                  }}
                                >
                                  Working remotely from
                                </span>
                              </button>

                              <button
                                style={{
                                  backgroundColor: "#ECE5DD",
                                  borderRadius: "20px",
                                  borderColor: "rgb(67, 197, 158)",
                                  border: "none",
                                  position: "absolute",
                                  bottom: "90px",
                                  left: "10px",
                                }}
                              >
                                <span
                                  style={{
                                    color: "black",
                                    fontSize: "18px",
                                    padding: "10px",
                                  }}
                                >
                                  Casablanca, Morocco
                                </span>
                              </button>

                              <button
                                style={{
                                  marginBottom: "15px",
                                  backgroundColor: "rgb(67, 197, 158)",
                                  borderRadius: "20px",
                                  borderColor: "rgb(67, 197, 158)",
                                  position: "absolute",
                                  bottom: "10px",
                                  left: "10px",
                                }}
                              >
                                <span
                                  style={{
                                    color: "white",
                                    fontSize: "22px",
                                    fontFamily: "'Noto Sans JP',  sans-serif",
                                    margin: "20px",
                                  }}
                                >
                                  <i
                                    className="icon-whatsapp"
                                    style={{
                                      marginRight: "7px",
                                      fontSize: "22px",
                                    }}
                                  />{" "}
                                  212 777 757 183
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </section> 
        */}

        <section
          id="colorlib-hero"
          className="js-fullheight"
          data-section="home"
        >
          <div className="flexslider js-fullheight" style={{marginTop: "50px"}}>
            <h1 style={{textAlign: "center", color: "rgb(67, 197, 158)"}}>About Me _</h1>
            <h2 style={{marginRight: "100px", marginLeft: "50px", color: "gray", lineHeight: 1.3}}>I'm a self taught web developer who is passionate about web technologies, I particularily love Material UI for its standard design and user experience. </h2>
            <h2 style={{marginRight: "100px", marginLeft: "50px", color: "gray"}}>
            When I'm not coding I'm either taking long city runs or surfing at the local beach!</h2>
            <h1 style={{marginLeft: "50px", textDecoration: "underline", marginTop: "50px", color: "rgb(67, 197, 158)"}}>Favorite Tech</h1>
            <ul style={{marginLeft: "50px"}}>
              <li>React</li>
              <li>Node</li>
              <li>Material UI</li>
              <li>Google Firebase</li>
              <li>Bootstrap</li>
              <li>Wordpress</li>
            </ul>
          </div>
        </section>

        
      </div>
    );
  }
}


